{
  "accountInformation": "اکاؤنٹ کی معلومات",
  "accountStatus": "اکاؤنٹ کی حیثیت",
  "active": "فعال",
  "admin": "ایڈمن",
  "adminBadge": "ایڈمن",
  "adminPrivileges": "ایڈمنسٹریٹر اختیارات",
  "aiDefaultHelp": "میں آج آپ کی کیسے مدد کر سکتا ہوں؟",
  "aiDepositHelp": "ڈپازٹ کے مسائل، تاخیر یا تصدیق کے بارے میں پوچھیں۔",
  "aiKycHelp": "KYC تصدیق اور دستاویزات کی ضروریات کے بارے میں پوچھیں۔",
  "aiLoginHelp": "لاگ ان، پاس ورڈ یا اکاؤنٹ رسائی کے مسائل کے بارے میں پوچھیں۔",
  "aiP2pHelp": "P2P آرڈرز، تنازعات یا ادائیگی کے مسائل کے بارے میں پوچھیں۔",
  "aiSupportAssistant": "AI سپورٹ اسسٹنٹ",
  "aiSupportAssistantText": "عام سوالات کے فوری جوابات حاصل کریں، یا ہماری ٹیم کے لیے ٹکٹ بنائیں۔",
  "aiWithdrawHelp": "نکاسی کی حیثیت، تاخیر یا ضروریات کے بارے میں پوچھیں۔",
  "askAiSupport": "AI سپورٹ سے پوچھیں",
  "bio": "پیشہ ورانہ تعارف",
  "capital": "سرمایہ",
  "changeImage": "تصویر تبدیل کریں",
  "cnicBack": "شناختی کارڈ (پشت)",
  "cnicFront": "شناختی کارڈ (سامنے)",
  "connectedWallet": "کنیکٹڈ والٹ",
  "country": "ملک",
  "createSupportTicket": "سپورٹ ٹکٹ بنائیں",
  "describeIssue": "اپنا مسئلہ بیان کریں",
  "disabled": "غیر فعال",
  "displayName": "ڈسپلے نیم",
  "editProfile": "پروفائل ایڈٹ کریں",
  "email": "ای میل",
  "emailOtpSendFailed": "توثیقی کوڈ بھیجنے میں ناکامی۔ براہ کرم دوبارہ کوشش کریں۔",
  "emailOtpSent": "توثیقی کوڈ آپ کے ای میل پر بھیج دیا گیا ہے۔",
  "emailVerification": "ای میل تصدیق",
  "emailVerifiedSuccessfully": "ای میل کامیابی سے تصدیق شدہ ہو گیا۔",
  "enabled": "فعال",
  "enterEmailOtp": "توثیقی کوڈ درج کریں",
  "enterOtpFirst": "براہ کرم پہلے توثیقی کوڈ درج کریں۔",
  "estimatedProfit": "متوقع منافع",
  "faceVerificationNotAutomated": "خودکار چہرہ تصدیق ابھی دستیاب نہیں۔ آپ کی اپ لوڈ کردہ سیلفی KYC منظوری کے دوران دستی طور پر جانچی جائے گی۔",
  "failedLoadNotifications": "اطلاعات لوڈ کرنے میں ناکامی۔",
  "failedMarkAllRead": "تمام کو پڑھا ہوا نشان زد کرنے میں ناکامی۔",
  "failedMarkRead": "پڑھا ہوا نشان زد کرنے میں ناکامی۔",
  "failedSubmitTicket": "ٹکٹ جمع کرانے میں ناکامی۔",
  "fullLegalName": "مکمل قانونی نام",
  "fullName": "پورا نام",
  "idNumber": "شناختی نمبر",
  "imagePreview": "تصویر کا پیش نظارہ",
  "imageTooLarge": "زیادہ سے زیادہ تصویر کا سائز 5 MB ہے۔",
  "inactive": "غیر فعال",
  "invalidImageType": "صرف JPG، PNG اور WEBP تصاویر کی اجازت ہے۔",
  "invalidOtp": "کوڈ غلط یا میعاد ختم ہو چکا ہے۔ براہ کرم دوبارہ کوشش کریں۔",
  "joinedDate": "شمولیت کی تاریخ",
  "kycStatus": "KYC کی حیثیت",
  "kycSubmissionFailed": "KYC جمع کرانے میں ناکامی۔",
  "kycSubmittedSuccessfully": "KYC کامیابی سے جمع کرا دیا گیا۔",
  "lastLogin": "آخری لاگ ان",
  "liquidationZone": "لیکویڈیشن زون",
  "loadingNotifications": "اطلاعات لوڈ ہو رہی ہیں...",
  "loadingProfile": "پروفائل لوڈ ہو رہا ہے...",
  "markAllRead": "تمام کو پڑھا ہوا نشان زد کریں",
  "mobileNumberCountryCode": "موبائل نمبر (ملکی کوڈ کے ساتھ)",
  "network": "نیٹ ورک",
  "noNotifications": "ابھی تک کوئی اطلاع نہیں۔",
  "noUtilityToolsFound": "کوئی یوٹیلیٹی ٹول نہیں ملا۔",
  "notSubmitted": "جمع نہیں کیا گیا",
  "notVerifiedEmail": "غیر تصدیق شدہ",
  "openTool": "ٹول کھولیں",
  "owner": "مالک",
  "ownerBadge": "مالک",
  "ownerControlCenter": "اونر کنٹرول سینٹر",
  "passportNationalId": "پاسپورٹ / قومی شناختی کارڈ",
  "pending": "پینڈنگ",
  "phoneNumber": "فون نمبر",
  "positionSize": "پوزیشن سائز",
  "positionValue": "پوزیشن ویلیو",
  "processing": "پروسیسنگ ہو رہی ہے...",
  "profileImage": "پروفائل تصویر",
  "profileSecurity": "پروفائل سیکیورٹی",
  "profileSubtitle": "اپنا پروفائل، KYC، والٹ اور سیکیورٹی کی معلومات مینج کریں۔",
  "profileTitle": "پروفائل",
  "profileUpdateFailed": "پروفائل اپ ڈیٹ نہیں ہوسکا",
  "profileUpdatedSuccessfully": "پروفائل کامیابی سے اپ ڈیٹ ہوگیا",
  "read": "پڑھا گیا",
  "rejected": "ریجیکٹڈ",
  "removeImage": "تصویر ہٹائیں",
  "required": "درکار",
  "riskAmount": "خطرے کی رقم",
  "riskPercent": "خطرے کا فیصد",
  "riskPositionCalculator": "رسک اور پوزیشن کیلکولیٹر",
  "role": "رول",
  "saveProfile": "پروفائل محفوظ کریں",
  "savingProfile": "پروفائل محفوظ ہو رہا ہے...",
  "securityLevel": "سیکیورٹی لیول",
  "selfieVerification": "سیلفی تصدیق",
  "sendEmailOtp": "ای میل OTP بھیجیں",
  "sendingEmailOtp": "بھیجا جا رہا ہے...",
  "serverError": "سرور میں خرابی۔",
  "sessionActive": "سیشن فعال",
  "sessionExpired": "سیشن ختم ہو گیا۔ براہ کرم دوبارہ لاگ ان کریں۔",
  "subject": "موضوع",
  "submitKyc": "KYC جمع کرائیں",
  "submitTicket": "ٹکٹ جمع کرائیں",
  "submittingKyc": "KYC جمع کیا جا رہا ہے...",
  "supportBadge": "سپورٹ",
  "supportRequiredFields": "موضوع اور تفصیل درکار ہیں۔",
  "telegram": "ٹیلیگرام",
  "ticketSubmittedSuccessfully": "ٹکٹ کامیابی سے جمع کرا دیا گیا۔",
  "tools": "ٹولز",
  "totalNotifications": "کل اطلاعات",
  "twoFactorStatus": "دو مرحلہ توثیق",
  "uid": "یو آئی ڈی",
  "unread": "غیر پڑھا گیا",
  "updateSuccessful": "پروفائل کامیابی سے اپ ڈیٹ ہوگیا۔",
  "uploadBackSide": "پشت کی طرف اپ لوڈ کریں",
  "uploadDocument": "دستاویز اپ لوڈ کریں",
  "uploadFrontSide": "سامنے کی طرف اپ لوڈ کریں",
  "uploadIdDocument": "براہ کرم شناختی دستاویز اپ لوڈ کریں۔",
  "uploadImage": "تصویر اپ لوڈ کریں",
  "uploadSelfie": "سیلفی اپ لوڈ کریں",
  "uploadSelfieRequired": "جمع کرانے سے پہلے براہ کرم سیلفی اپ لوڈ کریں۔",
  "user": "یوزر",
  "userId": "یوزر آئی ڈی",
  "userProfile": "یوزر پروفائل",
  "utilityTools": "یوٹیلیٹی ٹولز",
  "verified": "ویریفائیڈ",
  "verifiedBadge": "تصدیق شدہ",
  "verifiedEmail": "تصدیق شدہ",
  "verifyEmailFirst": "براہ کرم پہلے اپنے ای میل کی تصدیق کریں۔",
  "verifyingEmailOtp": "تصدیق ہو رہی ہے...",
  "walletAddress": "والٹ ایڈریس",
  "walletOrderTxOptional": "والیٹ ایڈریس، آرڈر آئی ڈی یا ٹرانزیکشن آئی ڈی (اختیاری)",
  "writeProfessionalBio": "اپنے بارے میں مختصر پروفیشنل تعارف لکھیں"
}